import { ApiNames, ApiProxy, ApiRequest, HttpMethod } from '@lib/api/apiProxy';

import { UserBaseBankDetails, UserFullBankDetails } from './types';

export class CastingJobsQueryApi {
  private static apiProxy = ApiProxy.getInstance();
  private static apiName = ApiNames.CastingJobs;

  public static getUserBaseBankDetails(
    userId: number
  ): Promise<UserBaseBankDetails | null> {
    const endpoint = `/users/${userId}/baseBankDetails`;
    return this.apiProxy.execute(new ApiRequest(this.apiName, endpoint));
  }

  public static getUserFullBankDetails(
    userId: number
  ): Promise<UserFullBankDetails | null> {
    const endpoint = `/users/${userId}/fullBankDetails`;
    return this.apiProxy.execute(new ApiRequest(this.apiName, endpoint));
  }

  public static searchWorkLocations(
    searchWorkLocationsDto?: SearchWorkLocationsDto
  ): Promise<WorkLocation[]> {
    const endpoint = `/workLocations/search`;
    return this.apiProxy.execute(
      new ApiRequest(
        this.apiName,
        endpoint,
        HttpMethod.POST,
        searchWorkLocationsDto || {}
      )
    );
  }

  // eslint-disable-next-line require-await
  public static async getActorShouldViewCountrySelection(
    email: string,
    tempPassword: string
  ): Promise<ShouldActorViewCountrySelectionInfo> {
    const endpoint = `/public/users/getActorShouldViewCountrySelection`;
    return this.apiProxy.execute(
      new ApiRequest(
        this.apiName,
        endpoint,
        HttpMethod.POST,
        {
          email,
          temp_password: tempPassword,
        },
        {},
        {},
        true
      )
    );
  }
}
